import { useNavigate } from "react-router-dom";

const UserBloggingNavigation = () => {
  const navigate = useNavigate();

  const goToUserBlogging = () => {
    navigate("/user-blogging"); // Ensure this route exists in your app
  };

  return { goToUserBlogging }; // ✅ Return an object
};

export default UserBloggingNavigation;

